export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13967.6250381d.jpg";